import React, { useEffect, useState } from "react";
import { DetailBox } from "../../molecules/DetailBox";
import { QuantamVideo } from "container/QuantamVideo";
import { Paginator } from "primereact/paginator";
import styled from "styled-components";

// Custom styled paginator component
const CustPaginator = styled(Paginator)`
  .p-paginator-first:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-prev:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-next:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-last:not(.p-disabled):not(.p-highlight):hover {
    color: #000;
  }

  .p-paginator-pages {
    margin: 0 1rem;
  }

  .p-paginator-pages .p-paginator-page.p-highlight {
    background: #010101;
    border-color: #010101;
    color: #fff;
    cursor: default;
  }

  .p-paginator-pages .p-paginator-page {
    border: none;
    border-radius: 50% !important;
    color: #010101;
    float: left;
    font-size: 18px;
    font-weight: 500;
    height: 2pc;
    line-height: 2pc;
    min-width: 2pc;
    padding: 0 !important;
    text-align: center;
    text-decoration: none;
  }

  .p-paginator-pages .p-paginator-page:hover {
    background: #010101;
    color: #fff;
    text-decoration: none;
  }
`;

// Styled div for individual item tags
const ItemTag = styled.div`
  .cust-title {
    font-size: 20px !important;
  }

  .cust-title:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const sliderdata = [
  {
    section: "QUANTUM MARKET INSIGHT",
    title: "After the Fed Cut After the Fed Cut After the Fed Cut",
    description: "Lorem Ipsum is simply dummy text of the printing and typesettin...",
    image: "media/blog-1-400x248 1.png",
  },
  {
    section: "QUANTUM MARKET INSIGHT",
    title: "After the Fed Cut",
    description: "Lorem Ipsum is simply dummy text of the printing and typesettin...",
    image: "media/blog-1-400x248 1 (1).png",
  },
  {
    section: "QUANTUM MARKET INSIGHT",
    title: "After the Fed Cut",
    description: "Lorem Ipsum is simply dummy text of the printing and typesettin...",
    image: "media/blog-1-400x248 1.png",
  },
  {
    section: "QUANTUM MARKET INSIGHT",
    title: "After the Fed Cut",
    description: "Lorem Ipsum is simply dummy text of the printing and typesettin...",
    image: "media/blog-1-400x248 1 (1).png",
  },
  {
    section: "QUANTUM MARKET INSIGHT",
    title: "After the Fed Cut",
    description: "Lorem Ipsum is simply dummy text of the printing and typesettin...",
    image: "media/blog-1-400x248 1.png",
  },
  {
    section: "QUANTUM MARKET INSIGHT",
    title: "After the Fed Cut",
    description: "Lorem Ipsum is simply dummy text of the printing and typesettin...",
    image: "media/blog-1-400x248 1 (1).png",
  },
  {
    section: "QUANTUM MARKET INSIGHT",
    title: "After the Fed Cut",
    description: "Lorem Ipsum is simply dummy text of the printing and typesettin...",
    image: "media/blog-1-400x248 1.png",
  },
  {
    section: "QUANTUM MARKET INSIGHT",
    title: "After the Fed Cut",
    description: "Lorem Ipsum is simply dummy text of the printing and typesettin...",
    image: "media/blog-1-400x248 1 (1).png",
  },
  {
    section: "QUANTUM MARKET INSIGHT",
    title: "After the Fed Cut",
    description: "Lorem Ipsum is simply dummy text of the printing and typesettin...",
    image: "media/blog-1-400x248 1.png",
  },
  {
    section: "QUANTUM MARKET INSIGHT",
    title: "After the Fed Cut",
    description: "Lorem Ipsum is simply dummy text of the printing and typesettin...",
    image: "media/blog-1-400x248 1 (1).png",
  },
  {
    section: "QUANTUM MARKET INSIGHT",
    title: "After the Fed Cut",
    description: "Lorem Ipsum is simply dummy text of the printing and typesettin...",
    image: "media/blog-1-400x248 1.png",
  },
  {
    section: "QUANTUM MARKET INSIGHT",
    title: "After the Fed Cut",
    description: "Lorem Ipsum is simply dummy text of the printing and typesettin...",
    image: "media/blog-1-400x248 1 (1).png",
  },
  {
    section: "QUANTUM MARKET INSIGHT",
    title: "After the Fed Cut",
    description: "Lorem Ipsum is simply dummy text of the printing and typesettin...",
    image: "media/blog-1-400x248 1.png",
  },
  {
    section: "QUANTUM MARKET INSIGHT",
    title: "After the Fed Cut",
    description: "Lorem Ipsum is simply dummy text of the printing and typesettin...",
    image: "media/blog-1-400x248 1 (1).png",
  },
  // ... (Other slider items)
];

const ItemSlider = () => {
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(9); // Set to 9 to display 9 items per page
  const totalPages = Math.ceil(sliderdata.length / rows); // Calculate total pages

  useEffect(() => {
    // Add event listener to detect clicks on the paginator's previous button
    const handlePrevClick = (event) => {
      if (
        event.target.classList.contains("pi-arrow-circle-left") ||
        event.target.classList.contains("pi-arrow-circle-right")
      ) {
        scrollToFirstSectionFromBottom();
      }
    };

    // Attach the event listener to the document (or paginator container)
    document.addEventListener("click", handlePrevClick);

    // Clean up event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handlePrevClick);
    };
  }, []);

  const onPageChange = (event) => {
    const newFirst = event.first;

    // Trigger the scroll function when the next or prev button is clicked
    if (newFirst !== first) {
      scrollToFirstSectionFromBottom();
    }

    setFirst(newFirst);
    setRows(event.rows);
  };

  // Scroll function to scroll to the first section from the bottom
  const scrollToFirstSectionFromBottom = () => {
    const sections = document.querySelectorAll("section");
    if (sections.length > 0) {
      const firstSectionFromBottom = sections[sections.length - 1];
      firstSectionFromBottom.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const itemTemplate = (item) => {
    return (
      <div
        className="col-lg-4 col-md-6 col-sm-12 mb-4 insightDiv"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <a href={`/insights-details`} className="no-underline">
          <ItemTag>
            {item?.image ? (
              <div className="image-container">
                <img
                  src={item?.image}
                  className="w-full zoom-image"
                  alt={item.title}
                />
              </div>
            ) : (
              <QuantamVideo item={item} />
            )}

            <div className="py-4 d-flex flex-column align-items-start">
              <p
                style={{
                  fontWeight: "500",
                  textTransform: "capitalize",
                  marginTop: "0px",
                  marginBottom:'0px',
                  color: "rgb(66, 66, 66)",
                  fontSize: "17px",
                }}
              >
                {item.section}
              </p>
              <p
                className="underlineText"
                style={{
                  fontWeight: "500",
                  color: "black",
                  fontSize: "20px",
                }}
              >
                {item.title}
              </p>
              <DetailBox style={{ marginTop: "-10px" }} details={item.description} />
            </div>
          </ItemTag>
        </a>
      </div>
    );
  };

  // Paginate the slider data according to the current page
  const paginatedData = sliderdata.slice(first, first + rows);

  return (
    <>
      <div className="row">
        {paginatedData.map((item, i) => {
          return itemTemplate(item, i);
        })}
      </div>

      <CustPaginator
        first={first}
        rows={rows}
        totalRecords={sliderdata.length}
        rowsPerPageOptions={[9]} // Pagination set for 9 items per page
        onPageChange={onPageChange} // Handle page change and call scroll
        prevPageLinkIcon={
          <i className="pi pi-arrow-circle-left" style={{ fontSize: "2rem" }}></i>
        }
        nextPageLinkIcon={
          <i className="pi pi-arrow-circle-right" style={{ fontSize: "2rem" }}></i>
        }
        template={{
          layout: "PrevPageLink CurrentPageReport NextPageLink",
          CurrentPageReport: (options) => {
            return (
              <span className="custom-paginator-text">
                Page {Math.ceil(first / rows) + 1} of {totalPages}
              </span>
            );
          },
        }}
      />
    </>
  );
};

export default ItemSlider;
